import { GET_ACCOUNT_DETAILS, LOGOUT, LOGGED } from '@/redux/actions/auth.actions'

import { DEFAULT_LANGUAGE } from '@/constants'
import {
	GET_USER_CONFIGURATIONS_BY_SITE_LOCATION,
	NAVIGATE_TO,
	NAVIGATION_END,
	RESET_ACTION_DONE,
	SET_ACTION_DONE,
	SET_NAVIGATION,
	FETCH_SUBMENU,
	HIDE_NOTIFICATION,
	SHOW_NOTIFICATION,
	COLLECTION_VIEW
} from '@/redux/actions/ui.actions'

const initialState = {
	navigateTo: {
		path: null,
		requiredUserStatus: null,
		state: {}
	},
	navigation: {
		language: DEFAULT_LANGUAGE,
		catalog: 16,
		preferredByUser: false,
		hasBeenActive: false
	},
	actionDone: null,
	userConfigurationsBySiteLocation: {},
	submenu: [],
	notifications: [],
	collectionView: {
		mode: 'grid',
		showPageHeaderSubmenu: false
	}
}

const navigateTo = (state = initialState.navigateTo, action) => {
	switch (action.type) {
		case NAVIGATE_TO:
			window.parent?.postMessage({ event: 'reduxNavigate', payload: action.payload }, '*')
			return action.payload

		case NAVIGATION_END:
			return {
				path: null,
				requiredUserStatus: null,
				state: {}
			}

		default:
			return state
	}
}

const navigation = (state = initialState.navigation, action) => {
	switch (action.type) {
		case SET_NAVIGATION:
			return { ...state, ...action.payload }

		default:
			return state
	}
}

const submenu = (state = initialState.submenu, action) => {
	switch (action.type) {
		case FETCH_SUBMENU.SUCCESS:
			return action.payload
		case FETCH_SUBMENU.FAILURE:
		case FETCH_SUBMENU.REQUEST:
			return state
		default:
			return state
	}
}

const actionDone = (state = initialState.actionDone, action) => {
	switch (action.type) {
		case SET_ACTION_DONE:
			return action.payload
		case RESET_ACTION_DONE:
			return null
		default:
			return state
	}
}

const userConfigurationsBySiteLocation = (state = initialState.userConfigurationsBySiteLocation, action) => {
	switch (action.type) {
		case GET_USER_CONFIGURATIONS_BY_SITE_LOCATION.SUCCESS:
			return {
				...state,
				[action.payload.siteLocation]: action.payload.userButtons
			}
		case GET_USER_CONFIGURATIONS_BY_SITE_LOCATION.REQUEST:
		case GET_USER_CONFIGURATIONS_BY_SITE_LOCATION.FAILURE:
			return {
				...state,
				[action.payload.siteLocation]: null
			}
		case LOGOUT.SUCCESS:
		case GET_ACCOUNT_DETAILS.SUCCESS:
			return {}
		default:
			return state
	}
}

const notifications = (state = initialState.notifications, action) => {
	switch (action.type) {
		case LOGGED:
		case SHOW_NOTIFICATION:
			return [...state, action.payload]
		case HIDE_NOTIFICATION:
			return state.filter((notification) => notification !== action.payload)
		default:
			return state
	}
}

const collectionView = (state = initialState.collectionView, action) => {
	switch (action.type) {
		case COLLECTION_VIEW:
			return { ...state, ...action.payload }
		default:
			return state
	}
}

export default {
	name: 'ui',
	reducers: {
		navigateTo,
		navigation,
		actionDone,
		userConfigurationsBySiteLocation,
		submenu,
		notifications,
		collectionView,
	}
}
